
import Index from '~/pages/index'
export default Index
